import { useState } from 'react'
import './Certificates.css'

import Certificate from '../../Components/Certificate/Certificate'
import SEO from '../../Components/SEO/SEO';
import PageTitle from '../../Hooks/PageTitle';

import rub_german_a11_certificate from '../../Media/Certificates.Media/rub_german_a11_certificate.jpg'
import efset_english_certificate from '../../Media/Certificates.Media/efset_english_certificate.jpg'
import transparent_language_english_certificate from '../../Media/Certificates.Media/transparent_language_english_certificate.jpg'
import strommen_english_certificate from '../../Media/Certificates.Media/strommen_english_certificate.jpg'
import fmpm_poster_competition_certificate from '../../Media/Certificates.Media/fmpm_poster_competition_certificate.jpg'
import ensas_hackathon_certificate from '../../Media/Certificates.Media/ensas_hackathon_certificate.jpg'
import robovation_certificate from '../../Media/Certificates.Media/robovation_certificate.jpg'
import hackai_certificate from '../../Media/Certificates.Media/hackai_certificate.jpg'
import organisation_semet27_certificate from '../../Media/Certificates.Media/organisation_semet27_certificate.jpg'
import hackathon_semet27_certificate from '../../Media/Certificates.Media/hackathon_semet27_certificate.jpg'
import poster_competition_certificate from '../../Media/Certificates.Media/poster_competition_certificate.jpg'
import expose_competition_certificate from '../../Media/Certificates.Media/expose_competition_certificate.jpg'
import udemy_iot_certificate from '../../Media/Certificates.Media/udemy_iot_certificate.jpg'
import sololearn_c_certificate from '../../Media/Certificates.Media/sololearn_c_certificate.jpg'

const Certificates = () => {
    PageTitle('Certificates');
	const [selectedType, setSelectedType] = useState('All Types');
	const [selectedSource, setSelectedSource] = useState('All Sources');
	const [selectedDate, setSelectedDate] = useState('All Years');

	const handleFilterChange = (certificate, setter) => {
		setter(certificate.target.value);
	};

	const filterCertificates = (certificate) => {
		const typeMatch = selectedType === 'All Types' || certificate.type === selectedType;
		const sourceMatch = selectedSource === 'All Sources' || certificate.source === selectedSource;
		const dateMatch = selectedDate === 'All Years' || certificate.date === selectedDate;

		return typeMatch && sourceMatch && dateMatch;
	};
	
	const certificates = [
		{
			onClick: () => window.open('https://drive.google.com/file/d/1wNXoPbDUF3uxp6yPJs3C0q4rJZDXi6bw/view?usp=sharing', '_blank'),
			date: '2026',
			image: rub_german_a11_certificate,
			type: 'Language Proficiency',
			title: "RUB - German A1.1 Certificate",
			description: "Successfully completed the General German Course A1.1 at RUB	, earning 5 ECTS credits. Demonstrated proficiency in German through assessments in grammar, vocabulary, reading comprehension, writing, and listening.",
			issuer: 'Ruhr University Bochum',
			source: 'University'
		},
		{
			onClick:() => window.open('https://cert.efset.org/en/Vwnxgt', '_blank'),
			date:'2025',
			image: efset_english_certificate,
			type: 'Language Proficiency',
			title: "EFSET - English Certificate C1 Advanced",
			description: "Score: 62/100, successfully achieved a C1 Advanced in the EFSET test, a globally recognized assessment of English proficiency. This certification demonstrates advanced skills in reading, listening, writing, and speaking.",
			issuer: 'EF SET',
			source: 'Other'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1fNJjtyjo1FfpiSaxDScdxu1-4Edzv5xa?usp=sharing', '_blank'),
			date:'2025',
			image: strommen_english_certificate,
			type: 'Language Proficiency',
			title: "CEFR - English Level Test",
			description: "Score: 88.89% - CEFR C2 Proficient. Almost native fluency, able to understand everything and express yourself fluently in complex situations with exceptional accuracy and confidence.",
			issuer: 'Strømmen',
			source: 'Other'
		},
		{
			onClick:() => window.open('https://education.transparent.com/mylearning/game/ng/#/english_test', '_blank'),
			date:'2025',
			image: transparent_language_english_certificate,
			type: 'Language Proficiency',
			title: "Transparent Language - English Proficiency Test",
			description: "Score: 83% - Successfully completed the Transparent Language English Test, with results estimating advanced proficiency across multiple international frameworks, including CEFR, IELTS, and TOEFL.",
			issuer: 'Transparent Language',
			source: 'Other'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1Nxwed-Y8gvKYyYpxVXDXJNL5G8_dNB8D?usp=drive_link', '_blank'),
			date:'2025',
			image: fmpm_poster_competition_certificate,
			type:'Achievement',
			title: "Poster Competition FMPM",
			description: "Awarded Best Scientific Poster for presenting PulseX at the FMPM competition. Recognized for excellence in research in AI-powered medical technology, highlighting embedded systems in telemedicine.",
			issuer: 'Pr. Mohammed Aziz BSISS',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1otsXWgNKjDnGUvkNGoxuHlHTFIQLdwEG?usp=sharing', '_blank'),
			date:'2025',
			image: ensas_hackathon_certificate,
			type:'Achievement',
			title: "Hackathon ENSAS",
			description: "Awarded for participating in the ENSAS Hackathon 2025, held at the National School of Applied Sciences in Safi. Contributed to building a deep learning model for anomaly detection in sardine cans, tackling real-world industrial challenges.",
			issuer: 'ENSA Safi, Industry Partners',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/17MpXl0_2w88u_bOW1LeAcuvNzstvfBIM?usp=sharing', '_blank'),
			date:'2025',
			image: robovation_certificate,
			type:'Participation',
			title: "Robovation Competition",
			description: "Participated in the Robovation Competition at Innovation City Marrakesh, presenting an AI-powered robotic prototype before a jury of 4 industry experts. Gained insights through expert feedback and explored emerging trends in robotics.",
			issuer: 'Cherkaoui El Modafar',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/17MpXl0_2w88u_bOW1LeAcuvNzstvfBIM?usp=sharing', '_blank'),
			date:'2025',
			image: hackai_certificate,
			type:'Attendance',
			title: "1337 HackAI Hackathon",
			description: "Certificate of participation awarded at HackAI Hackathon 2025, held at UM6P and organized by 1337AI. Recognized for innovative solutions and commitment to advancing AI, during a 4-day competition focused on GenAI and open innovation challenges.",
			issuer: '1337AI, UM6P, Hugging Face',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1v5nysUDUu3z5qklCObnXTRojTMbYCTZX?usp=sharing', '_blank'),
			date:'2025',
			image: organisation_semet27_certificate,
			type:'Organization',
			title: "SEMET'27 Organization Appreciation",
			description: "Appreciation certificate for attending SEMET'27, helping in organization, and contributing to activities including the poster competition, exposition, and hackathon showing innovation and collaboration.",
			issuer: 'Dean of the Faculty of Sciences Semlalia',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1S6RbvRdpxvmJOnivzDEAg4-_2TZTd73N?usp=sharing', '_blank'),
			date:'2025',
			image: hackathon_semet27_certificate,
			type:'Participation',
			title:"Hackathon SEMET'27",
			description: "Certificate of participation awarded for taking part in the SEMET'27 Hackathon, where our team developed AquaBot an AI-driven solution for sustainable water management. Earned 2nd place among competitive teams through innovation and collaboration.",
			issuer: 'Dean of the Faculty of Sciences Semlalia',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1S6Zd227x_bw62283rvJfz1H9dvdH_240?usp=sharing', '_blank'),
			date:'2025',
			image: poster_competition_certificate,
			type:'Participation',
			title:"Poster Competition SEMET'27",
			description: "Certificate of participation awarded for competing in a poster competition with NeuroDrive an intelligent vehicle automation project. Alongside teammate Zahra Abouhane, earning 5th place among standout entries.",
			issuer: 'Dean of the Faculty of Sciences Semlalia',
			source: 'University'
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1UgP04TOpvdJuGSbz01mjDCEdxgoomcQn?usp=sharing', '_blank'),
			date:'2025',
			image: expose_competition_certificate,
			type:'Participation',
			title:"Exposition Competition SEMET'27",
			description: "Participation certificate for presenting the NeuroDrive project at SEMET'27's exposition competition. Showcased the intelligent vehicle automation system with teammate Zahra Abouhane to attendees and evaluators.",
			issuer: 'Dean of the Faculty of Sciences Semlalia',
			source: 'University'
		},
		{
			onClick:() => window.open('https://www.udemy.com/certificate/UC-f5cd0dfd-f9ec-471c-aa16-8e0a14c36b25/', '_blank'),
			date:'2025',
			image: udemy_iot_certificate,
			type: 'Education',
			title: "Internet of Things Online Course",
			description: "Successfully completed the Internet of Things online course on Udemy, covering fundamental concepts, connected devices, and applications. Gained practical insights into IoT systems and their implementations.",
			issuer: 'Makeintern Course, Learntoupgrade',
			source: 'Udemy'
		},
		{
			onClick:() => window.open('https://www.sololearn.com/en/certificates/CT-Z6HPV0XZ', '_blank'),
			date:'2020',
			image: sololearn_c_certificate,
			type: 'Education',
			title: "C Programming Certificate",
			description: "Completed the C Programming course on SoloLearn, demonstrating solid understanding of core concepts, and practical coding skills, including algorithm design, memory management, and efficient code implementation.",
			issuer: 'Yeva Hyusyan',
			source: 'SoloLearn'
		},
	];

	return (
		<>
			<SEO 
                title="Certificates"
                description="Professional certifications and achievements in AI, machine learning, deep learning, web development, and computer science. Credentials from top institutions and platforms including Coursera, Google, IBM, and more."
                url="https://yassinebazgour.vercel.app/Certificates"
                keywords="AI certifications, machine learning certificates, deep learning credentials, web development certifications, Python certifications, TensorFlow certification, professional achievements, computer science credentials"
            />
			<section className='certificates-section'>
				<span className='certificates-title'>Certificates</span>
				<span className='certificates-description'>A collection of certificates earned through courses I've completed or<br/>competitions contributed to.</span>
				<span className='certificates-count-span'>
                    Earned Certificates:
                    <span className='certificates-count-number'> {certificates.filter(c => c.image).length}</span>
                </span>
				<div className='certificates-selects-container'>
					<select className='certificates-select certificates-type-select' onChange={(e) => handleFilterChange(e, setSelectedType)}>
						<option>All Types</option>
						<option>Education</option>
						<option>Participation</option>
						<option>Achievement</option>
						<option>Attendance</option>
						<option>Organization</option>
						<option>Language Proficiency</option>
					</select>
					<select className='certificates-select certificates-source-select' onChange={(e) => handleFilterChange(e, setSelectedSource)}>
						<option>All Sources</option>
						<option>University</option>
						{/* <option>Coursera</option> */}
						{/* <option>Udemy</option> */}
						<option>SoloLearn</option>
						<option>Other</option>
					</select>
					<select className='certificates-select certificates-date-select' onChange={(e) => handleFilterChange(e, setSelectedDate)}>
						<option>All Years</option>
						<option>2026</option>
						<option>2025</option>
						<option>2020</option>
					</select>
				</div>
				<div className='certificates-container'>
					{certificates.filter(filterCertificates).length === 0 ? (
						<span className='no-available-certificate'>No certificates are available for the selected filters. 😔</span>
					) : (
						certificates.filter(filterCertificates).map((certificate, index) => (
							<Certificate 
								key={index}
								{...certificate}
							/>
						))
					)}
					</div>

			</section>
		</>
	)
}

export default Certificates
